import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import messages from 'app/_authenticated/funds/messages';
import WithdrawOtp from 'components/Otp/WithdrawOtp/WithdrawOtp';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { z } from 'zod';

const searchParamsSchema = z.object({
  acceptAbsolution: z.boolean().default(false),
  otpType: z.string(),
});

export const Route = createFileRoute(
  '/_authenticated/funds/withdraw/fiat/$productCode/otp',
)({
  component: BankWithdrawOtp,
  validateSearch: zodValidator(searchParamsSchema),
});

function BankWithdrawOtp() {
  const { productCode } = Route.useParams();
  const { acceptAbsolution, otpType } = Route.useSearch();

  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page="/funds/withdraw/fiat/2FA"
      />
      <div className="px-6 py-4">
        <WithdrawOtp
          withdrawalType="fiat"
          otpType={otpType}
          acceptAbsolution={acceptAbsolution}
        />
      </div>
    </>
  );
}
